import WhitelistedIPs from '@/views/whitelisted-ips/whitelisted-ips.vue'
import ShowWhitelistedIP from '@/views/whitelisted-ips/show-whitelisted-ip.vue'
import { WhitelistedIpsRouteNames } from '@/router/routes-names'

export const whitelistedIpsRoutes = [
    {
        path: '/whitelisted-ips',
        name: WhitelistedIpsRouteNames.LIST,
        component: WhitelistedIPs,
        props: true
    },
    {
        path: '/whitelisted-ips/show/:ip/:description/:creationTime',
        name: WhitelistedIpsRouteNames.SHOW,
        component: ShowWhitelistedIP
    }
]
